import { Rooftop } from "../app/class/rooftop";
import { DealerShip } from "./dealer-ship";
import { Settings } from "./setting";

export class GeneralService {
    constructor() {
        
    }
  public  ValidatePercent(event: any) {
        if (!event.target.value) {
            event.target.value = "";
        }
        if (event.target.value > 100) {
            event.target.value = 100;
        }
    }
    public ValidateMoney(event: any) {
        if (!event.target.value) {
            event.target.value = "";
        }
        if (event.target.value < 0) {
            event.target.value = 0;
        }

    }
    public findGetParamRooftop(rooftops: Array<Rooftop>, select: string, settings: Settings): any {
        let DataRooftops: Array<Rooftop> = rooftops;
        let DataDealerShipId: number;
        let first: boolean = false;
        let find: boolean = false;

        let dealerShipId: DealerShip;
        if (window.localStorage.getItem('dealerShipId')) {
            dealerShipId = JSON.parse(window.localStorage.getItem('dealerShipId'));
        }
        else {
            dealerShipId = new DealerShip(String(settings.dealerGroupId),DataRooftops[0].id);
        }
        let index: number = (select === "0") ? 0 : DataRooftops.findIndex(element => String(element.id) === select);
        let indexClient: number = dealerShipId.list.findIndex(element => String(element.client) === String(settings.dealerGroupId));
        for (let i = 0; i < DataRooftops.length; i++) {
            if (select === undefined) {
                if (String(settings.dealerShipId) !== "0") {
                    if (DataRooftops[i].id === String(settings.dealerShipId)) {
                        DataRooftops[i].class = 'm--active';
                        find = true;
                    }
                    else {
                        DataRooftops[i].class = '';
                    }
                }
                else {
                    first = true;
                    DataRooftops[i].class = '';
                }
            }
            else {
                if (i === index) {
                    DataRooftops[i].class = 'm--active';
                    DataDealerShipId = Number(DataRooftops[i].id);
                    find = true;
                }
                else {
                    DataRooftops[i].class = '';
                }
            }
        }
        if (first) {
            find = true;
            DataDealerShipId = Number(DataRooftops[0].id);
            DataRooftops[0].class = 'm--active';

            if (indexClient !== (-1)) {
                dealerShipId.list[indexClient].id = DataRooftops[0].id;
            }
            else {
                dealerShipId.list.push({ client: String(settings.dealerGroupId), id: DataRooftops[0].id });
            }
            window.localStorage.setItem('dealerShipId', JSON.stringify(dealerShipId));

        }

        return {
            rooftops: DataRooftops,
            dealerShipId: DataDealerShipId,
            find: find
        }

    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/general.service.ts